module.exports = __webpack_public_path__ + "static/media/Koobot_Processed_08B.a73eb544.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/Koobot_Processed_08B.mp3
// module id = 110
// module chunks = 0